import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { store } from './modules/ewerp/store';
import App from './App.vue';
import router from './routes';

import { registerSW } from 'virtual:pwa-register';
import { useAuthStore } from '@/modules/auth/stores/authStore';

import 'bootstrap';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faWindows } from '@fortawesome/free-brands-svg-icons';

import {
  faBars,
  faSync,
  faDownload,
  faShareSquare,
  faTrash,
  faCopy,
  faPaperPlane,
  faPlus,
  faUsers,
  faChevronRight,
  faList,
  faAddressCard,
  faObjectGroup,
  faLayerGroup,
  faBoxOpen,
  faWineBottle,
  faAngleDoubleDown,
  faListOl,
  faSearchPlus,
  faEnvelope,
  faInfoCircle,
  faInfo,
  faChevronLeft,
  faArrowRight,
  faArrowRightToBracket,
  faArrowRightFromBracket,
  faClipboard,
  faFlask,
  faFolder,
  faBoxesStacked,
  faPrint,
  faFileArrowDown,
  faMinus,
  faRotate,
  faCheck,
  faCheckDouble,
  faXmark,
  faPen,
  faMagnifyingGlassPlus,
  faCircleCheck,
  faMagnifyingGlass,
  faArrowDownLong,
  faArrowUpLong,
  faFileInvoice,
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faArrowRight,
  faArrowRightToBracket,
  faArrowRightFromBracket,
  faBars,
  faCheck,
  faCheckDouble,
  faCircleCheck,
  faSync,
  faDownload,
  faFileArrowDown,
  faShareSquare,
  faTrash,
  faCopy,
  faPaperPlane,
  faPen,
  faPlus,
  faUsers,
  faChevronRight,
  faChevronLeft,
  faList,
  faListOl,
  faAddressCard,
  faObjectGroup,
  faLayerGroup,
  faBoxOpen,
  faWineBottle,
  faAngleDoubleDown,
  faSearchPlus,
  faEnvelope,
  faInfoCircle,
  faInfo,
  faClipboard,
  faFlask,
  faFolder,
  faBoxesStacked,
  faPrint,
  faWindows,
  faXmark,
  faMinus,
  faRotate,
  faMagnifyingGlassPlus,
  faMagnifyingGlass,
  faArrowDownLong,
  faArrowUpLong,
  faFileInvoice
);

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

registerSW({ immediate: true });

async function bootstrap() {
  const app = createApp(App);
  app.use(createPinia());

  app.use(store); // Vuex Store einbinden, solange Vuex noch verwendet wird

  app.use(router);
  app.component('font-awesome-icon', FontAwesomeIcon);

  const auth = useAuthStore();
  await auth.initAuth();

  if (!auth.isAuthenticated) {
    router.push({ name: 'auth.login' });
    // auth.login();
  }
  // else {
  //   console.log(router.currentRoute);
  //   router.push({ name: 'ewwms.bestellungen' });
  // }

  app.mount('#app');
}

bootstrap();
